import React from 'react';
import ReactDOM from 'react-dom';
import { ChatbotWrapper } from './src-components-Chat-ChatWrapper.js';
import { allowedLocales } from './src-config-ubik-config.js';
import { isChatbotEnabled } from './src-utils-init-chatbot-utils.js';

const initChatbot = (config) => {
  try {
    if (typeof document === "undefined" || !document.body) {
      console.error("initChatbot can only be called in a browser environment with a valid document.body.");
      return;
    }
    if (allowedLocales.includes(config?.locale?.toLowerCase())) {
      let chatbotRoot = document?.getElementById("chatbot-root");
      if (chatbotRoot) {
        console.warn("Chatbot is already initialized.");
        return;
      }
      chatbotRoot = document?.createElement("div");
      chatbotRoot.id = "chatbot-root";
      chatbotRoot.className = "swan";
      document?.body?.appendChild(chatbotRoot);
      const enableChatbot = isChatbotEnabled(config.pageName);
      ReactDOM.render(/* @__PURE__ */ React.createElement(ChatbotWrapper, { locale: config.locale?.toLowerCase(), tenant: config.tenant, enableChatbot }), chatbotRoot);
    }
  } catch (error) {
    console.error("Failed to initialize chatbot:", error);
    if (window && window.newrelic && window.newrelic.addPageAction) {
      window.newrelic.addPageAction("ca-chatbot-init-error", { logLevel: "error", message: error.message, errorType: "initError" });
    }
  }
};

export { initChatbot };
//# sourceMappingURL=src-initChatbot.js.map
